import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Droplets, Zap, BrainCircuit } from 'lucide-react';
export function TriggerMap() {
  const triggers = [{
    icon: Flame,
    title: 'Heat Surge Wake',
    desc: 'Hot, sweaty, uncomfortable. Your body temperature spikes and wakes you up.',
    color: 'bg-orange-100 text-orange-600'
  }, {
    icon: Droplets,
    title: 'Pee Wake',
    desc: 'Bathroom trip that wakes your whole brain. Hard to settle back down.',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: Zap,
    title: 'Cortisol-Wired Wake',
    desc: "Revved body, fast mind. You feel 'tired but on'. Heart might be pounding.",
    color: 'bg-yellow-100 text-yellow-700'
  }, {
    icon: BrainCircuit,
    title: 'Spiral Thoughts Wake',
    desc: "Your brain starts a trial against you. Worrying about everything you've ever done.",
    color: 'bg-purple-100 text-purple-700'
  }];
  return <section className="py-24 px-4 bg-[#1e2a38] text-white relative overflow-hidden" data-id="element-112">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-113">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-114">
          <defs data-id="element-115">
            <pattern id="trigger-waves" x="0" y="0" width="100" height="40" patternUnits="userSpaceOnUse" data-id="element-116">
              <path d="M0 20 Q25 40 50 20 T100 20" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-117" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#trigger-waves)" data-id="element-118" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-121">
            The 4-Trigger Night Map
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-122">
            When you wake up at 3AM, you're not waking up for 27 reasons. Most
            of the time it's one of these four.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-123">
          {triggers.map((trigger, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#2a3441] p-8 rounded-2xl border border-gray-700 hover:border-[#c9a07a] transition-colors duration-300" data-id="element-124">
              <div className={`w-14 h-14 rounded-xl ${trigger.color} flex items-center justify-center mb-6`} data-id="element-125">
                <trigger.icon size={28} data-id="element-126" />
              </div>
              <h3 className="text-2xl font-serif mb-3 text-[#c9a07a]" data-id="element-127">
                {trigger.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-128">{trigger.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center bg-[#c9a07a]/10 p-8 rounded-2xl border border-[#c9a07a]/30 max-w-3xl mx-auto" data-id="element-129">
          <p className="text-lg md:text-xl" data-id="element-130">
            Once you know which one it is, you stop doing random things… and you
            run the matching{' '}
            <span className="text-[#c9a07a] font-bold" data-id="element-131">
              5-minute back-to-sleep micro-protocol
            </span>
            .
          </p>
        </div>
      </div>
    </section>;
}